import gql from 'graphql-tag';

export default gql`
  query loginPhoneExists($phoneNumber: String!) {
    loginPhoneExists(phoneNumber: $phoneNumber)
  }
`;
